import { TextField } from '@boltenergy-be/design-system'
import { EMAIL } from 'constants/regex'
import { useFormContext } from 'react-hook-form'
import { EmailProps } from 'components/inputs/email/types'
import { useTranslation } from 'next-i18next/pages'
import { getFieldError, getFieldName } from 'components/inputs/utils'
import { IS_STAGING } from 'constants/envs'

const Email = ({ errorMessage, hiddenLabel, isRepeat, parentDotPath, required = true, placeholder, label, ...props }: EmailProps) => {
  // Constants
  const emailKey = isRepeat ? 'repeatEmail' : 'email'

  // React Hook Form
  const {
    formState: { errors },
    register,
    watch
  } = useFormContext()

  // i18n
  const { t } = useTranslation(['commonFormFields', 'validation', 'common'])

  return (
    <TextField
      {...props}
      {...register(getFieldName(emailKey, parentDotPath), {
        maxLength: {
          value: 255,
          message: t('validation:max.string', {
            attribute: t('commonFormFields:email.label'),
            length: 255
          })
        },
        required: {
          value: required,
          message: t('validation:required')
        },
        ...(isRepeat && {
          validate: (value: string) => value.trim() === (watch('email') as string).trim() || t('commonFormFields:email.errors.notEqual')
        }),
        pattern: {
          value: EMAIL,
          message: t('commonFormFields:email.errors.invalid')
        }
      })}
      placeholder={placeholder}
      error={errorMessage || getFieldError(emailKey, parentDotPath, errors)?.message}
      label={label || t(`commonFormFields:email.${isRepeat ? 'repeat' : 'label'}`)}
      hiddenLabel={hiddenLabel}
      onPaste={(e) => isRepeat && !IS_STAGING && e.preventDefault()}
      type="email"
      {...(!required && { optionalText: t('common:optional') })}
    />
  )
}

export default Email
